import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const SpMessage = () => {
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [message, setMessage] = useState("");
  const [editMessage, setEditMessage] = useState("");
  const [editId, setEditId] = useState(null);
  const [messages, setMessages] = useState([]);

  const baseUrl = "https://api.experts4u.in/api/v2/MessageSp";

  // Toolbar options
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["clean"]
    ],
  };

  // Fetch Messages
  const fetchMessages = async () => {
    try {
      const response = await axios.get(`${baseUrl}/GetMessageSp`);
      if (response.data.success) {
        setMessages(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching messages:", error);
    }
  };

  useEffect(() => {
    fetchMessages();
  }, []);

  // Add Message
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!message.trim()) {
      Swal.fire("Error!", "Please enter message", "error");
      return;
    }

    try {
      await axios.post(`${baseUrl}/CreateMessageSp`, {
        message: message, // Save HTML directly
      });

      Swal.fire("Success!", "Message created successfully!", "success");

      setMessage("");
      setShowModal(false);
      fetchMessages();
    } catch (error) {
      console.error(error);
    }
  };

  // Edit Open
  const handleEdit = (msg, id) => {
    setEditMessage(msg); // Already HTML
    setEditId(id);
    setShowEditModal(true);
  };

  // Update Message
  const handleUpdate = async (e) => {
    e.preventDefault();

    if (!editMessage.trim()) {
      Swal.fire("Error!", "Please enter message", "error");
      return;
    }

    try {
      await axios.put(`${baseUrl}/UpdateMessageSp/${editId}`, {
        message: editMessage,
      });

      Swal.fire("Success!", "Message updated successfully!", "success");

      setEditMessage("");
      setEditId(null);
      setShowEditModal(false);
      fetchMessages();
    } catch (error) {
      console.error(error);
    }
  };

  // Delete
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure?")) return;

    try {
      await axios.delete(`${baseUrl}/DeleteMessageSp/${id}`);
      Swal.fire("Deleted!", "Message deleted successfully!", "success");
      fetchMessages();
    } catch (error) {
      console.error(error);
    }
  };

  const handleStatusChange = async (id, newStatus) => {
    try {
      const response = await axios.put(`${baseUrl}/statusUpdate/${id}`, {
        status: newStatus === 'active'
      });
      if (response.data.success) {
        fetchMessages();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Failed to update status!",
        })
      }
    } catch (error) {
      console.error('Error updating status:', error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Failed to update status!",
      })
    }
  };

  return (
    <div className="container-fluid py-5 mt-4" style={{ padding: "0 5%" }}>
      <div className="card mb-3">
        <div className="card-header d-flex align-items-center">
          <h4 className="card-title">Message</h4>
          <button
            className="btn btn-primary btn-sm ml-auto"
            onClick={() => setShowModal(true)}
          >
            Add New
          </button>
        </div>
      </div>

      {/* TABLE */}
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Message</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {messages.map((msg) => (
            <tr key={msg._id}>
              <td
                style={{ width: "1200px", maxWidth: "1150px", wordBreak: "break-word" }}
                dangerouslySetInnerHTML={{ __html: msg.message }}
              />
              <td>{msg.status ? "Active" : "Inactive"}</td>
              <td >
                <div className="d-flex" style={{ gap: "0.2rem" }}>
                <button
                  className="btn btn-primary btn-sm me-2"
                  onClick={() => handleEdit(msg.message, msg._id)}
                >
                  Edit
                </button>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => handleDelete(msg._id)}
                >
                  Delete
                </button>
                <select 
                  className="custom-select custom-select-sm" 
                  style={{ width: "80px", color: "#333", fontWeight: "500" }}
                  name="status" 
                  value={msg.status ? 'active' : 'inactive'} 
                  onChange={(e) => handleStatusChange(msg._id, e.target.value)} 
                  >
                  <option value="active" >Active</option>
                  <option value="inactive">Inactive</option>
                </select>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* ADD MODAL */}
      {showModal && (
        <div className="modal show d-block">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Add Message</h5>
                <button onClick={() => setShowModal(false)}>X</button>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="modal-body">
                  <ReactQuill
                    value={message}
                    onChange={setMessage}
                    modules={modules}
                  />
                </div>
                <div className="modal-footer">
                  <button type="submit" className="btn btn-primary">
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* EDIT MODAL */}
      {showEditModal && (
        <div className="modal show d-block">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Edit Message</h5>
                <button onClick={() => setShowEditModal(false)}>X</button>
              </div>
              <form onSubmit={handleUpdate}>
                <div className="modal-body">
                  <ReactQuill
                    value={editMessage}
                    onChange={setEditMessage}
                    modules={modules}
                  />
                </div>
                <div className="modal-footer">
                  <button type="submit" className="btn btn-primary">
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SpMessage;
